module.exports = __webpack_public_path__ + "img/bg-quac-principal.3941b0b8.svg";